// extracted by mini-css-extract-plugin
export var rowNumbered = "row-numbered_IFFoBJp76xP0nNmEsFaM";